
import { PALLET_MENU_ITEM } from "@/consts";
import PalletTable from "@/components/barcodeSystem/inventory/PalletTable.vue";
import PalletFilters from "@/components/barcodeSystem/inventory/PalletFilters.vue";
import InventoryActions from "@/components/barcodeSystem/inventory/InventoryActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import Component from "vue-class-component";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
    PalletTable,
    InventoryActions,
    PalletFilters
  }
})
export default class InventoryItems extends Vue {
  showPalletFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  PALLET_MENU_ITEM: any = PALLET_MENU_ITEM;

  get palletFields() {
    return inventoryModuleState.palletFields;
  }

  async created() {
  }

  async loadMoreItems() {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getPallets(null);
    await inventoryModuleState.setLoading(false);
  }

  async onSort(s) {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.applyPalletSort(s);
    await inventoryModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    inventoryModuleState.toggleItemField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.PALLET_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get dataRetreived() {
    if(inventoryModuleState.palletData)
      return true;
    return false;
  }
}


